import { memo } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIErrorMessage from 'UIComponents/error/UIErrorMessage';
import styled from 'styled-components';
import { jsx as _jsx } from "react/jsx-runtime";
const Wrapper = styled.div.withConfig({
  displayName: "CalleeError__Wrapper",
  componentId: "fny5dp-0"
})(["width:320px;margin-left:auto;margin-right:auto;"]);
const StyledUIErrorMessage = styled(UIErrorMessage).withConfig({
  displayName: "CalleeError__StyledUIErrorMessage",
  componentId: "fny5dp-1"
})(["img{margin-bottom:15px;}"]);
function CalleeError() {
  return /*#__PURE__*/_jsx(Wrapper, {
    children: /*#__PURE__*/_jsx(StyledUIErrorMessage, {
      illustration: "errors/general",
      illustrationProps: {
        width: 80
      },
      title: /*#__PURE__*/_jsx("div", {
        className: "is--heading-4",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "callSettingsWidget.popoverError.title"
        })
      }),
      className: "p-x-2 m-y-4",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "callSettingsWidget.popoverError.body"
      })
    })
  });
}
export default /*#__PURE__*/memo(CalleeError);